import http from '.';
import {
  apiForgotPass,
  apiLogin,
  apiLogout,
  apiUpdatePass,
  apiVerifyCode,
} from './apiRouter';

const logIn = (body) => http.post(apiLogin, body);

const logOut = (body) => http.post(apiLogout, body);
const confirmEmail = (body) => http.post(apiForgotPass, body);
const updatePass = (body) => http.patch(apiForgotPass, body);
const updatePassByAdmin = (body) => http.post(apiUpdatePass, body);
const verifyCodeWithChangePass = (body) => http.post(apiVerifyCode, body);

const AuthServices = {
  logIn,
  logOut,
  confirmEmail,
  updatePass,
  verifyCodeWithChangePass,
  updatePassByAdmin,
};

export default AuthServices;
